export default __webpack_public_path__ + "static/media/node-red-icon.27923c09.png";